<template>
	<div>
		<form-field-wrap
			v-if="presetStepType || presetStepFavorite"
			:field-props="presetField"
			:field-value="presetLocation.display_path_first"
			:input-focus="inputFocus"
			:is-error="isPresetFieldError"
			:is-switch="isSwitch"
			:with-label="presetLocation.hasOwnProperty('withLabel') ? presetLocation.withLabel : true"
		>
			<vue-select
				:options="presetField.ITEMS"
				:value="presetLocation.display_path_first"
				:components="components"
				:input-id="presetField.ID ? presetField.ID : presetField.CODE"
				:loading="presetsLoading"
				:data-vv-as="presetField.TITLE"
				:name="presetField.CODE"
				@search:focus="labelSwitch('focus')"
				@search:blur="labelSwitch('blur')"
				@input="onSelectPresetLocation">
				<template slot="no-options">
					<span v-html="presetEmptyTitle"></span>
				</template>
				<template slot="option" slot-scope="option">
					<span class="location_list_item" v-html="option.display_path_first"></span>
				</template>
				<template slot="selected-option" slot-scope="option">
					<span class="location_selected" v-html="option.label"></span>
				</template>
			</vue-select>
		</form-field-wrap>

		<div :class="afterPropClass">
			<form-field-wrap
				:field-props="fieldProps"
				:field-value="fieldProps.VALUE"
				:input-focus="inputFocus"
				:class="{'form-field_filled': isUsedAlternative}"
				:is-error="isError"
				:is-switch="isSwitch"
				:with-label="fieldProps.hasOwnProperty('withLabel') ? fieldProps.withLabel : true"
			>
				<template v-if="isUsedAlternative">
					<div class="b-location__alternative" @click="onClearAlternative">
						<span class="b-location__alternative_name" v-html="this.searchPhrase"></span>
						<span class="b-location__alternative_clear" >&times;</span>
					</div>
				</template>
				<vue-select
					:options="fieldProps.ITEMS ? fieldProps.ITEMS : result.LOCATION"
					:value="valueSelect"
					:components="components"
					:input-id="fieldProps.ID ? fieldProps.ID : fieldProps.CODE"
					:loading="loading"
					v-validate="rules"
					:data-vv-as="fieldProps.TITLE"
					:name="fieldProps.CODE"
					@search:focus="labelSwitch('focus')"
					@search:blur="labelSwitch('blur')"
					@search="onSearch"
					@input="onSelectLocation">
					<template slot="no-options">
						<span v-if="useAlternative && isSearched" @click="onUseAlternative"
						      v-html="loc.CITRUS_LOCATION_USE_AS_ALTERNATIVE.replace('#NAME#', searchPhrase)"></span>
						<span v-else v-html="labelForSearch"></span>
					</template>
					<template slot="option" slot-scope="option">
							<span class="location_list_item" v-html="option.display_path_first"></span>
					</template>
					<template slot="selected-option" slot-scope="option">
						<span v-show="!isUsedAlternative" class="location_selected" v-html="valueSelect"></span>
					</template>
				</vue-select>
			</form-field-wrap>
			<slot name="after-prop"></slot>
		</div>
	</div>
</template>

<script>
	import {Vue} from "ui.vue";

	export default {
		name: "LocationByStep",
		props: {
			presetStepType: {
				type: [Array, Object, Number, String, Boolean],
				default: false,
			},
			presetStepFavorite: {
				type: [Array, Object, Number, String, Boolean],
				default: false,
			},
			presetTitle: {
				type: String,
				default: ""
			},
			presetEmptyTitle: {
				type: String,
				default: "Not found"
			},
			useAlternative: {
				type: Boolean,
				default: false,
			},
			afterPropClass: {
				type: String,
				default: ""
			},
			alternativeSelectedValue: {
				type: String,
				default: ""
			},
			selectedTitle: {
				type: [String, Number],
				default: '',
			},
		},
		watch: {
			alternativeSelectedValue() {
				this.searchPhrase = this.alternativeSelectedValue;
				this.isUsedAlternative = this.alternativeSelectedValue.length > 0;
				this.init();
			}
		},
		data() {
			return {
				isSearched: false,
				searchPhrase: this.alternativeSelectedValue,
				isUsedAlternative: this.alternativeSelectedValue.length > 0,

				presetField: {
					CODE: this.fieldProps.CODE + "_PRESET_TYPE",
					IS_LOCATION: this.fieldProps.IS_LOCATION,
					PLACEHOLDER: this.fieldProps.PLACEHOLDER,
					REQUIRED: this.fieldProps.REQUIRED,
					ROW_CLASS: this.fieldProps.ROW_CLASS,
					TITLE: this.presetTitle,
					TYPE: this.fieldProps.TYPE,
					ITEMS: [],
				},
				presetLocation: {
					id: 0,
					display_path_first: "",
					value: "",
				},
				presetsLoading: false,

				result: {
					"ERRORS": {},
					"LOCATION": []
				},
				locationsPageN: 0,
				active: false,
				valueSelect: this.selectedTitle,
				valueCode: this.selectedCode,
				inputFocus: false,
				loading: false,
				error: false,
			}
		},
		computed: {
			loc() {
				return Vue.getFilteredPhrases("CITRUS_LOCATION_");
			},
			isPresetFieldError() {
				return this.errors.first(this.presetField.CODE);
			}
		},
		created() {
			this.init();

			if (this.presetStepType || this.presetStepFavorite) {
				this.presetsLoading = true;
				let data = this.prepareAjaxData(false, false, false);

				if (this.presetStepType) {
					data.filter["=TYPE_ID"] = this.presetStepType;
				}
				if (this.presetStepFavorite) {
					data.filter["=CODE"] = this.presetStepFavorite;
				}
				this.ajaxRequest(data, false, "", (result) => {
					this.presetField.ITEMS = this.parseResponseData(result);
					this.presetsLoading = false;
				}, () => {
					this.presetsLoading = false;
				});
			}
		},
		methods: {
			onSelectPresetLocation(location) {
				if (!location) {
					location = {
						id: 0,
						display_path_first: "",
						value: ""
					};
				}

				this.presetLocation = location;
				this.setValueSelect("");

				this.isUsedAlternative = false;
				this.searchPhrase = "";

				this.$emit("location-select", {location: location, selected: "", isPreset: true});
				this.$emit("input", "");
				this.$emit("input-alternative", this.searchPhrase);
				this.result.LOCATION = [];
			},
			onUseAlternative() {
				this.isUsedAlternative = true;

				this.setValueSelect(this.presetLocation.value);
				this.$emit("location-select", {location: this.presetLocation});
				this.$emit("input", this.presetLocation.value);
				this.$emit("input-alternative", this.searchPhrase);
				setTimeout(this.checkValid, 0);
			},
			onClearAlternative() {
				this.isUsedAlternative = false;
				this.isSearched = false;
				this.searchPhrase = "";

				this.setValueSelect("");
				this.$emit("location-select", {location: {value: ""}});
				this.$emit("input", "");
				this.$emit("input-alternative", this.searchPhrase);
				this.checkValid();
			},
			onSearch(search, loading) {
				if (search.length > 1 && this.isSearch) {
					this.isUsedAlternative = false;
					this.isSearched = true;
					this.searchPhrase = search;

					loading(true);
					this.search(loading, search);
				}
			},
			onSelectLocation(location) {
				this.isUsedAlternative = false;
				this.searchPhrase = "";
				this.isSearched = false;

				if (!location) {
					this.setValueSelect("");
					this.$emit("location-select", {location: {value: ""}, selected: this.valueSelect});
					this.$emit("input", "");
				}
				else {
					this.setSelectedLocation(location);
				}

				this.$emit("input-alternative", this.searchPhrase);
			},
			search(loading, phrase, code) {
				let data = this.prepareAjaxData(false, phrase, code);
				if (!this.presetLocation.id) {
					return;
				}

				data["filter[=PARENT_ID]"] = this.presetLocation.id;

				this.ajaxRequest(data, loading, code);
			},
			onAjaxSuccess(result, code, loading) {
				let res = this.parseResponseData(result);
				this.result.LOCATION = res;
				if (loading) {
					loading(false);
				}
				this.loading = false;

				if (code && res && res[0]) {
					let location = res[0];

					if (!this.isUsedAlternative) {
						if (location.hasOwnProperty('parent') && location.parent) {
							this.presetLocation = location.parent;
						}

						this.setValueSelect(location)
						this.onSelectLocation(location);
					}
					else {
						this.presetLocation = location;
						this.setValueSelect(this.presetLocation.value);
						this.$emit("location-select", {location: this.presetLocation});
						this.$emit("input", this.presetLocation.value);
						this.$emit("input-alternative", this.searchPhrase);
					}

					setTimeout(this.checkValid, 0);
				}
			},
			setValueSelect(location) {
				this.valueSelect = typeof location == "string"
					? location
					: location && typeof location == "object" ? location.display_path_first : "";
			}
		}
	};
</script>